const updateStickyHeader = () => {
  let announcement_bar = document.querySelector('.announcement-bar');
  let sticky_header = document.querySelector('sticky-header');
  let main_content = document.querySelector('#MainContent');

  if (announcement_bar && sticky_header) {
    sticky_header.style.setProperty('top', `${announcement_bar.clientHeight}px`, 'important');
  } else if (sticky_header) {
    sticky_header.style.setProperty('top', '0px', 'important');
  }

  let sticky_height = 0;
  if (sticky_header) {
    sticky_height = sticky_header.clientHeight + (announcement_bar ? announcement_bar.clientHeight : 0);
  }



  // if (main_content) {
  //   main_content.style.marginTop = `${sticky_height}px`;
  // }
}
document.addEventListener('DOMContentLoaded', updateStickyHeader);
window.onresize = updateStickyHeader;
var shopify_events = ['shopify:section:load', 'shopify:section:unload', 'shopify:section:select', 'shopify:section:deselect'];
shopify_events.forEach(function(event_type) {
  document.addEventListener(event_type, updateStickyHeader);
});
